import { apiConstants } from "@data/constants/apiConstants"
import { schoolCardReportService } from "../../../services/schoolCardReportService"

const initialState = {
    hash: "",
    analysisData: {},
    file: null,
}

export default function schoolCardReport(state = initialState, action) {
    switch (action.type) {
        case schoolCardReportService.processFile.name + apiConstants._SUCCESS:

            return {
                ...state,
                hash: action.data.hash,
            }

        case schoolCardReportService.getAnalysisDataByHash.name +
            apiConstants._SUCCESS:
            return {
                ...state,
                analysisData: action.data,
            }
        default:
            return state
    }
}
